import React from 'react';
import { Link } from 'react-router-dom';

export default function EmptyHeader() {
  return (
    <header>
      <div className="header-container">
        <div className="title">
          <Link to="/" className="title-link">
            <span className="title-text">
              {'THINGDOMS'.split('').map((letter, index) => (
                <span key={index} className="title-letter" style={{ '--letter-index': index }}>
                  {letter}
                </span>
              ))}
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
};
